// src/components/projects/overview/ProjectDetailsCard.jsx
import React from 'react';
import {
  Box, Typography, Paper, Chip, useTheme
} from '@mui/material';
import { formatDate } from '../../../utils/dateUtils';

const ProjectDetailsCard = ({ project }) => {
  const theme = useTheme();
  
  // Early return if project is null
  if (!project) {
    return null;
  }
  
  return (
    <Paper sx={{ mb: 3 }}>
      <Box sx={{ p: 2, borderBottom: `1px solid ${theme.palette.divider}` }}>
        <Typography variant="h6">
          Project Details
        </Typography>
      </Box>
      
      <Box sx={{ p: 2 }}>
        <DetailItem 
          label="Client" 
          value={project.clientId?.name || 'Not specified'} 
        />
        
        <DetailItem 
          label="Brand" 
          value={project.brandId?.name || 'Not specified'} 
        />
        
        <DetailItem 
          label="Project Type" 
          value={project.type?.replace(/_/g, ' ') || 'Not specified'} 
          capitalize
        />
        
        <DetailItem 
          label="Start Date" 
          value={formatDate(project.dates?.plannedStartDate)} 
        />
        
        <DetailItem 
          label="End Date" 
          value={formatDate(project.dates?.plannedEndDate)} 
        />
        
        {project.regions && project.regions.length > 0 && (
          <ChipListItem 
            label="Regions" 
            items={project.regions} 
          />
        )}
        
        {project.tags && project.tags.length > 0 && (
          <ChipListItem 
            label="Tags" 
            items={project.tags} 
          />
        )}
      </Box>
    </Paper>
  );
};

// Helper component for detail items
const DetailItem = ({ label, value, capitalize = false }) => (
  <Box sx={{ mb: 2 }}>
    <Typography variant="body2" color="text.secondary">
      {label}
    </Typography>
    <Typography 
      variant="body1" 
      sx={capitalize ? { textTransform: 'capitalize' } : {}}
    >
      {value}
    </Typography>
  </Box>
);

// Helper component for chip lists
const ChipListItem = ({ label, items }) => (
  <Box sx={{ mb: 2 }}>
    <Typography variant="body2" color="text.secondary" gutterBottom>
      {label}
    </Typography>
    <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
      {items.map(item => (
        <Chip key={item} label={item} size="small" variant="outlined" />
      ))}
    </Box>
  </Box>
);

export default ProjectDetailsCard;